import { useDriverFreightRates } from '../../api/useDriverFreightRates'
import { useFormatter } from '@api/useFormatter'
import { ErrorNotification, Vertical } from '@gravitate-js/excalibrr'
import { Form, Spin } from 'antd'
import React, { useState } from 'react'
import { EditSectionHeader } from './components/EditSectionHeader'
import { MileageRows } from './components/MileageRows'
import { TableHeader } from './components/TableHeader'

export function Table({ selectedRow, canEdit, setSelectedRow }) {
  const [isEditing, setIsEditing] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true, null)
  const { driverFreightSetRatesMutation } = useDriverFreightRates()
  const updateRates = async (formData) => {
    setIsLoading(true)
    try {
      const updated = await driverFreightSetRatesMutation.mutateAsync({
        driver_rate_id: selectedRow.id,
        rates: formData.rates,
      })
      form.setFieldsValue(updated)
      setSelectedRow((row) => ({ ...row, rates: updated.rates }))
    } catch (error) {
      ErrorNotification(error)
    } finally {
      setIsEditing(false)
      setIsLoading(false)
    }
  }

  selectedRow && form.setFieldsValue({ ...selectedRow })

  return (
    <Vertical className={'full-height-width'}>
      <TableHeader selectedRow={selectedRow} />
      <Vertical style={{ maxHeight: '45px', minHeight: '45px' }}>
        <EditSectionHeader
          title='Miles and Rates'
          editing={isEditing}
          onEdit={() => canEdit && setIsEditing(true)}
          onSubmit={() => form.submit()}
        />
      </Vertical>
      <Form
        form={form}
        size='small'
        onFinish={updateRates}
        onFinishFailed={ErrorNotification}
        className={'full-height-width'}
        style={{ overflowY: 'hidden' }}
      >
        {isLoading && (
          <Vertical className='p-4' verticalCenter>
            <Spin size='large' />
          </Vertical>
        )}
        {!isLoading && selectedRow && (
          <MileageRows
            rates={selectedRow?.rates}
            isEditing={isEditing}
            formattedCurrency={formattedCurrency}
            selectedRow={selectedRow}
          />
        )}
      </Form>
    </Vertical>
  )
}
